(() => {
  const TARGET = 'OU.';
  const SKIP_SELECTOR = 'script, style, noscript, input, textarea, select, code, pre, svg, [contenteditable], [contenteditable="true"], [data-no-brand], .brand-dot';

  const wrapInNode = (textNode) => {
    const text = textNode.nodeValue;
    const idx = text.indexOf(TARGET);
    if (idx === -1) return;

    const wrapper = document.createElement('span');
    wrapper.className = 'brand-name';
    let cursor = 0;
    let i = idx;
    while (i !== -1) {
      if (i > cursor) wrapper.appendChild(document.createTextNode(text.slice(cursor, i)));
      wrapper.appendChild(document.createTextNode('OU'));
      const dot = document.createElement('span');
      dot.className = 'brand-dot';
      dot.setAttribute('aria-hidden', 'false');
      dot.textContent = '.';
      wrapper.appendChild(dot);
      cursor = i + TARGET.length;
      i = text.indexOf(TARGET, cursor);
    }
    if (cursor < text.length) wrapper.appendChild(document.createTextNode(text.slice(cursor)));
    textNode.parentNode.replaceChild(wrapper, textNode);
  };

  const shouldSkip = (el) => !el || el.closest(SKIP_SELECTOR);

  const walk = (root) => {
    if (!root || shouldSkip(root.nodeType === 1 ? root : root.parentElement)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (!node.nodeValue || node.nodeValue.indexOf(TARGET) === -1) return NodeFilter.FILTER_REJECT;
        if (shouldSkip(node.parentElement)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    const targets = [];
    let n;
    while ((n = walker.nextNode())) targets.push(n);
    targets.forEach(wrapInNode);
  };

  const run = () => {
    if (document.body) walk(document.body);

    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        m.addedNodes.forEach((node) => {
          if (node.nodeType === 1) walk(node);
          else if (node.nodeType === 3 && node.parentElement && !shouldSkip(node.parentElement)) wrapInNode(node);
        });
      }
    });
    const watchRoots = document.querySelectorAll('header, cart-drawer, quick-view, [data-brand-watch]');
    watchRoots.forEach((el) => observer.observe(el, { childList: true, subtree: true }));
  };

  const schedule = () => (window.requestIdleCallback || ((cb) => setTimeout(cb, 1)))(run);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }
})();
